import CardProps from './type';
import CardStyled from './styled';

const Card = ({ children, ...props }: CardProps) => {
  return <CardStyled {...props}>{children}</CardStyled>;
};

export default Card;
